import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { IAlertDialogProps } from './types/alert-dialog-props';
import DialogResult from './types/dialog-result-enum';

function AlertDialog({
  closeHandler: dialogCloseHandler,
  message,
  isDialogOpen,
  title
}: IAlertDialogProps) {
  return (
    <Dialog
      open={isDialogOpen}
      onClose={() => dialogCloseHandler(DialogResult.NO)}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      id='confirmation-dialog'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => dialogCloseHandler(DialogResult.NO)}
        >
          No
        </Button>
        <Button
          color='primary'
          variant='outlined'
          onClick={() => dialogCloseHandler(DialogResult.YES)}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { AlertDialog, DialogResult };
